import Component from "../abstracts/Component";
const {Crawler} = require('./../../../../node_modules/es6-crawler-detect/src')
import WishlistComponent from "../components/WishlistComponent";

/**
 Recommendation Engine Component - Common SF/Google logic
 */
export default class RecommendationEngineLogic extends Component {

  constructor(compEl, selectors, constants) {
    super(compEl);
    this.$component = compEl;
    this.SELECTORS = selectors;
    this.CONSTANTS = constants;
    this.wishlistComponent = new WishlistComponent();
  }

  render(selectors) {
    this.recommendationEngineProductsContainer = this.$component.querySelector(this.SELECTORS.recommendationEngineProductsContainer);
    if (this.$component) {
      this.importSlick();
      this.setup(this.$component);
    }
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    let template = recommendationComponent.dataset.template;

    opts.webRecommendationHtmlData = true;
    opts.template = template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode; // BIA-2346

    if (recommendationComponent.dataset.orderCode) {
      opts.orderCode = recommendationComponent.dataset.orderCode;
      let checkoutTemplate = this.CONSTANTS.CHECKOUT_TEMPLATE;

      if (typeof (utag_data) !== 'undefined' && utag_data !== null && template === checkoutTemplate) {
        let products = utag_data.products;
        if (typeof (products) !== 'undefined' && products !== null) {
          try {
            opts.productsData = JSON.stringify(products);
          } catch (e) {
            this.warn("error trasform products to JSON");
          }
        }
        if (typeof (utag_data.order_total) !== 'undefined' && utag_data.order_total !== null) opts.totalPrice = utag_data.order_total;
      }
    }
    if(recommendationComponent.dataset.isPdp && recommendationComponent.dataset.isPdp === 'true') {
      opts.collection = recommendationComponent.dataset.collection;
    }

    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode; // BIA-2346
    return opts;
  }

  async fetchServer(paramsObj) {
    const params = new URLSearchParams();
    for (let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }
    const response = await fetch(this.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20")).catch((error) => {
      console.warn(error);
    });

    if (response.ok) {
      const text = await response.text();
      if (text && text.trim() !== "") {
        this.manageSuccessfulResponse(text);
      } else {
        await this.tryAgain();
      }
    } else {
      await this.tryAgain();
    }
  }

  async tryAgain() {
    const opts = this.getSimilarOpts(this.$component);
    const params = new URLSearchParams();
    for (let key in opts) {
      params.append(key, opts[key]);
    }
    const response = await fetch(this.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20")).catch((error) => {
      console.warn(error);
    });
    if (response.ok) {
      const text = await response.text();
      if (text && text.trim() !== "") {
        this.manageSuccessfulResponse(text);
      } else {
        this.$component.classList.add("--hidden");
      }
    } else {
      this.$component.classList.add("--hidden");
    }
  }

  manageSuccessfulResponse(text) {
    this.recommendationEngineProductsContainer.innerHTML = text;
    const carouselCards = this.recommendationEngineProductsContainer.querySelector(this.SELECTORS.carouselCards);

    // rec response can be OK but have no products, needs check
    if (carouselCards) {
      this.initCarousel(carouselCards);
      if (this.$component.dataset.hasTitle === 'true') {
        this.moduleTitle();
      }

      this.wishlistComponent.listenBtnWish(this.recommendationEngineProductsContainer.querySelectorAll(this.SELECTORS.wishlistButton));

      this.$emit(this.$customEvents.RECOMMENDATION_EVENTS.loaded,
        {
          carouselType: 'googleRecommendation',
          carousel: this,
          carouselTitle: this.$component.querySelector("#servingConfigId")?.value,
        }
      );
    } else {
      console.warn('recommendation response successful but it has no products.')
    }
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        // initialized after successful fetch
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      },
    );
  }

  initCarousel(carouselContainer = this.recommendationEngineProductsContainer.querySelector(this.SELECTORS.carouselCards)) {

    const nextArrow = this.$component.querySelector(this.SELECTORS.nextArrow);
    const prevArrow = this.$component.querySelector(this.SELECTORS.prevArrow);

    const customPaging = function(slider, i) {
      return $('<button><i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i></button>');
    };

    const options = {
      arrows: true,
      slidesToShow: this.$component.dataset.template === 't-checkout-confirm' ? 3 : 4,
      slidesToScroll: this.$component.dataset.template === 't-checkout-confirm' ? 3 : 4,
      dots: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      customPaging: customPaging,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            infinite: false,
            slidesToShow: 1.8,
            slidesToScroll: 1,
          },
        },
      ],
    };
    $(carouselContainer).slick(options);

    $(nextArrow).on('click', function() {
      const $arrow = $(this);
      $arrow.addClass('animate-arrow-next');
      setTimeout(() => $arrow.removeClass('animate-arrow-next'), 600);
    });
    $(prevArrow).on('click', function() {
      const $arrow = $(this);
      $arrow.addClass('animate-arrow-prev');
      setTimeout(() => $arrow.removeClass('animate-arrow-prev'), 600);
    });
  }

  // used by Google Rec
  moduleTitle() {
    const titleModel = this.$component.querySelector(this.SELECTORS.carouselTitleModel);
    const title = this.$component.querySelector(this.SELECTORS.carouselTitle);
    if (typeof (titleModel) !== 'undefined' && titleModel !== null && titleModel.value !== '' && typeof (title) !== 'undefined' && title !== null) {
      title.innerHTML = titleModel.value;
    }
  }

  setup(recommendationComponent) {
    const userAgentString = navigator.userAgent;
    const CrawlerDetector = new Crawler();
    if(!CrawlerDetector.isCrawler(userAgentString)) {
      this.fetchServer(this.getMarketingOpts(recommendationComponent));
    } else {
      this.$component.classList.add("--hidden");
    }
  }
}
